module.exports = __webpack_public_path__ + "img/turntable.b6e4f812.png";